import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import './Navbar.css';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showBuyersDropdown, setShowBuyersDropdown] = useState(false);
  const [showSellersDropdown, setShowSellersDropdown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const buyersDropdownRef = useRef(null);
  const sellersDropdownRef = useRef(null);

  useEffect(() => {
    if (!isHomePage) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  // Handle clicking outside dropdowns to close them
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (buyersDropdownRef.current && !buyersDropdownRef.current.contains(event.target)) {
        setShowBuyersDropdown(false);
      }
      if (sellersDropdownRef.current && !sellersDropdownRef.current.contains(event.target)) {
        setShowSellersDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleBuyersDropdownOptionClick = (option) => {
    setShowBuyersDropdown(false);
    if (option === 'buying-services') {
      navigate('/buying-services');
    } else if (option === 'mortgage-calculator') {
      navigate('/mortgage-calculator');
    } else if (option === 'search') {
      navigate('/search');
    }
  };

  const handleSellersDropdownOptionClick = (option) => {
    setShowSellersDropdown(false);
    if (option === 'selling-services') {
      navigate('/selling-services');
    } else if (option === 'home-valuation') {
      // Show coming soon message or implement home valuation functionality
      alert('Home Valuation feature coming soon! Please call (650) 283-3537 for a personalized home valuation.');
    }
  };

  return (
    <nav className={`navbar ${isScrolled && isHomePage ? 'scrolled' : ''} ${!isHomePage ? 'not-home' : ''}`}>
      <div className="nav-links">
        <Link to="/" className="nav-button">Home</Link>
        <Link to="/listings" className="nav-button">Current Listings</Link>
      </div>
      <div className="nav-brand">
      </div>
      <div className="nav-contact">
        <div className="dropdown-container" ref={buyersDropdownRef}>
          <span
            className="nav-button"
            onClick={() => setShowBuyersDropdown(!showBuyersDropdown)}
          >
            For Buyers
          </span>
          {showBuyersDropdown && (
            <div className="dropdown-menu">
              <div className="dropdown-item" onClick={() => handleBuyersDropdownOptionClick('buying-services')}>
                Buying Services
              </div>
              <div className="dropdown-item" onClick={() => handleBuyersDropdownOptionClick('mortgage-calculator')}>
                Mortgage Calculator
              </div>
              <div className="dropdown-item" onClick={() => handleBuyersDropdownOptionClick('search')}>
                Property Wish List
              </div>
            </div>
          )}
        </div>
        <div className="dropdown-container" ref={sellersDropdownRef}>
          <span
            className="nav-button"
            onClick={() => setShowSellersDropdown(!showSellersDropdown)}
          >
            For Sellers
          </span>
          {showSellersDropdown && (
            <div className="dropdown-menu">
              <div className="dropdown-item" onClick={() => handleSellersDropdownOptionClick('selling-services')}>
                Selling Services
              </div>
              <div className="dropdown-item" onClick={() => handleSellersDropdownOptionClick('home-valuation')}>
                Home Valuation
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;